import * as React from 'react';
import { ToastContainer, ToastOptions, toast } from 'react-toastify';

import { SignalREvents } from '@app/AppConstants/SignalR';
import { ApiUrls } from '@app/AppConstants/ApiUrls';
import ApiService from '@app/Services/ApiService';
import { devInfoStore } from '@app/Stores/DevInfoStore';
import { signalRService } from '@app/Services/SignalRService';

export class NotificationContainer extends React.Component {
    render() {
        return <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            draggable
            pauseOnHover
            theme="colored"
            closeButton
        />;
    }
}

export class NotificationHandler {
    static subscribeToNotifications() {
        signalRService.subscribeToGroup<string>(SignalREvents.success, NotificationHandler.onOperationSuccessHandler);
        signalRService.subscribeToGroup<string>(SignalREvents.warning, NotificationHandler.onOperationWarningHandler);
        signalRService.subscribeToGroup<string>(SignalREvents.error, NotificationHandler.onOperationErrorHandler);
        signalRService.subscribeToGroup<string>(SignalREvents.info, NotificationHandler.onOperationInfoHandler);
    }

    public static onOperationSuccessHandler(_: string, message: string) {
        NotificationHandler.showSuccess(message);
    }

    public static onOperationWarningHandler(_: string, message: string) {
        NotificationHandler.showWarning(message);
    }

    public static onOperationErrorHandler(_: string, message: string) {
        NotificationHandler.showError(message);
    }

    public static onOperationInfoHandler(_: string, message: string) {
        NotificationHandler.showInfo(message);
    }

    public static suppressError(message: string){
        const excludeErrors: {pattern: string, reason: string}[] = [{
            pattern: '__gCrWeb',
            //https://stackoverflow.com/questions/26483541/referenceerror-cant-find-variable-gcrweb
            reason: 'Edge on iOS bug'
        }, {
            pattern: 'instantSearchSDKJSBridgeClearHighlight',
            //https://stackoverflow.com/questions/69261499/what-is-instantsearchsdkjsbridgeclearhighlight
            reason: 'Edge on iOS bug'
        }];

        for(const p of excludeErrors){
            if (message && message.indexOf(p.pattern) !== -1){
                //do not report
                return true;
            }
        }

        return false;
    }

    public static showConsoleError(errorParameters: ErrorEvent | {error: string, message: string, filename?: string, lineno?: number, colno?: number}) {
        const msg = errorParameters.message;
        const url = errorParameters.filename;
        const lineNo = errorParameters.lineno;
        const columnNo = errorParameters.colno;
        const error = errorParameters.error;

        let message = 'script error';
        if (msg.indexOf(message) > -1) {
            message = 'Script Error: See Browser Console for Detail';
        } else {
            const messageParts = ['Message: ' + msg, 'URL: ' + (url || ''), 'Line: ' + (lineNo || ''), 'Column: ' + (columnNo || '')];
            if (error && error.stack){
                messageParts.push('Stack: ' + JSON.stringify(error.stack));
            }
            message = messageParts.join(' - ');
        }

        if (this.suppressError(message)){
            return;
        }

        if (devInfoStore.isDevelopment) {
            NotificationHandler.showError(message, 'Error');
        }
        
        let screenSize = '';
        if (screen.width) {
            const width = (screen.width) ? screen.width : '';
            const height = (screen.height) ? screen.height : '';
            screenSize += '' + width + ' x ' + height;
        }

        const params = {
            message: message,
            url: window.location.href,
            source: url || '' + ' Line: ' + lineNo + ' Column: ' + columnNo,
            navigatorUserAgent: navigator.userAgent,
            navigatorVendor: navigator.vendor,
            screenSize: screenSize
        };
        void ApiService.postData(ApiUrls.ErrorUrl, params);
    }

    public static showError(message: React.ReactNode, title: string = 'Error') {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.error(content);
    }

    public static showInfo(message: string, title: string = 'Info') {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.info(content);
    }

    public static showWarning(message: string, title: string = 'Warning') {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.warning(content);
    }

    public static showSuccess(message: string, title: string = 'Success', optionsOverride?: ToastOptions) {
        const content = (
            <div>
                <div>{title}</div>
                <div>{message}</div>
            </div>
        );
        toast.success(content, optionsOverride);
    }
}

NotificationHandler.subscribeToNotifications();
